import VueDraggable from 'vuedraggable'
import Vue from 'vue'

Vue.use(VueDraggable)